import _ from 'lodash';

// run on each draft to transform raw server response to our expected state structure
const processDraft = (draft) => {
    try {
        const messageInfo = JSON.parse(draft?.MessageText);
        return {
            threadID: draft.ID,
            creatorContactID: `${draft.SenderClass}_${draft.SenderID}`,
            published: draft.Created,
            announcementType: 'draft',
            ...messageInfo,
        };
    } catch (error) {
        return null;
    }
};

export const draftAnnouncementsTransformer = (data) => {
    try {
        const payload = JSON.parse(data);
        const transformedPayload = { drafts: {} };

        _.forIn(payload.Drafts, (draft) => {
            const processedDraft = processDraft(draft);
            if (!draft.Deleted && processedDraft) {
                transformedPayload.drafts[draft.ID] = processedDraft;
            }
        });

        return transformedPayload;
    } catch (error) {
        // swallow the exception and let the api error handler take care of it.
    }
    return data;
};
